import React from 'react';
import { Link } from 'react-router-dom';
import {
  Row, Col, Nav, Tab,
} from 'react-bootstrap5';

import routes from 'app/routes';
import MyStyle from './MyStyle';
import MyPreferences from './MyPreferences';

export default function Index() {
  return (
    <div className="content">
      <section>
        <Row className="align-items-center">
          <Col>
            <h1>Learning Style</h1>
          </Col>

          <Col xs="auto">
            <Link
              to={routes.members.learningStyle.new}
              className="btn btn-primary"
            >
              Edit
            </Link>
          </Col>
        </Row>
      </section>

      <Tab.Container
        id="learning-style"
        defaultActiveKey="my-style"
      >
        <Nav fill justify variant="tabs">
          <Nav.Item>
            <Nav.Link eventKey="my-style">
              My Style
            </Nav.Link>
          </Nav.Item>

          <Nav.Item>
            <Nav.Link eventKey="my-preferences">
              My Preferences
            </Nav.Link>
          </Nav.Item>
        </Nav>

        <Tab.Content>
          <Tab.Pane eventKey="my-style" className="px-sm-4 px-xxl-5">
            <MyStyle />
          </Tab.Pane>

          <Tab.Pane eventKey="my-preferences" className="px-sm-4 px-xxl-5">
            <MyPreferences />
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </div>
  );
}
